import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from './../../shared/components/searchForm/SearchForm';
import {userSearchFields} from '../utils/searchFields';
import DataTable, {possibleStatus} from './../../shared/components/table/DataTable';
import {I18n} from 'react-redux-i18n';
import { appModules } from '../../roles/components/UserHasPermission';

const UsersPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    handleAddButtonClicked,
    data = [],
    entityList,
    roleList,
    onRowClick,
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    sort: {
        property,
        direction
    },
    onPageChange,
    onPageSizeChange,
}) => {
    const columns = [{
        Header: I18n.t("users.list.firstName"),
        accessor: "firstName",
        sortable: true
    }, {
        Header: I18n.t("users.list.lastName"),
        accessor: "lastName",
        sortable: true
    }, {
        Header: I18n.t("email"),
        accessor: "email",
        sortable: true
    }, {
        Header: I18n.t("users.list.entity"),
        id: "entity",
        accessor: user => user.entity.name
    }, {
        Header: I18n.t("users.list.role"),
        id: "role",
        accessor: user => user.role.name,
        sortable: true
    }];
    return <div className="page_background">
        <SearchForm
            content={userSearchFields(searchFieldsValues, entityList, roleList)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            handleAddButtonClicked={handleAddButtonClicked}
            appModule={appModules.USER}
        />
        <div>
            <DataTable
                //State dependent
                data={data}
                onRowClick={onRowClick}

                //Pagination
                pages={pages}
                selectedPage={currentPage}
                pageSize={pageSize}
                sortDirection={direction}
                sortProperty={property}
                totalElements={totalElements}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                onSortChanged={handleSortChanged}

                //State independent / Configuration
                columns={columns}
                hasStatusBar={true}
                statusBarAccessor={user => {
                    switch (user.status) {
                        case 'ACTIVE':
                            return possibleStatus.active;
                        case 'INACTIVE':
                            return possibleStatus.inactive;
                        default:
                            return possibleStatus.uncertain;
                    }
                }}
            />
        </div>
    </div>
}

UsersPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number,
}

export default UsersPage;